import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.04541 1L5.05696 5L9.06851 1"
        stroke="#787876"
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default Icon;
